import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.StatementBalance.SendEmail.IRequest;
type Response = Api.Core.StatementBalance.SendEmail.IResponse;
type Headers = Api.Core.StatementBalance.SendEmail.IHeaders;
const url = '/api/DealerManagement/StatementBalance/SendEmail';
export default async function statementBalanceSendEmailApi(body: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
